import type { Schema } from "../../core/render/logic/Markdoc/index";

export const alfa: Schema = {
	render: "Alfa",
};

export const beta: Schema = {
	render: "Beta",
};
